/**
 * 列表页表格高度：行少时随内容增高、分页紧贴表格；行多时在 maxHeight 内表头固定、表体滚动。
 * @param {number} topOffset 表格上方占用（顶栏/标签/筛选/工具栏等，px）
 * @param {number} bottomReserve 预留给分页与底边距（px）
 */
export function calcListTableMaxHeight(topOffset = 268, bottomReserve = 52) {
  const h = window.innerHeight - topOffset - bottomReserve;
  return Math.max(240, h);
}

export function bindListTableMaxHeight(vm, key = "listTableMaxHeight", topOffset = 268, bottomReserve = 52) {
  const update = () => {
    vm[key] = calcListTableMaxHeight(topOffset, bottomReserve);
  };
  update();
  window.addEventListener("resize", update);
  return () => window.removeEventListener("resize", update);
}
